import React from 'react';
import ReactDOM from 'react-dom/client';
import { Quill } from 'react-quill';
import App from './App';
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { msalInstance } from "./config/msalConfig";
import { getTheme } from "./theme/theme";
import { ColorModeProvider, useColorMode } from "./context/ColorModeContext";
import { applyUiConfig } from "./config/uiConfig";

applyUiConfig();

// quill-image-resize-module reads a global window.Quill at load time; set it before importing the module
window.Quill = Quill;

const registerImageResizeModule = import("quill-image-resize-module/src/ImageResize.js").then((mod) => {
  Quill.register("modules/imageResize", mod.default);
});

function ThemedApp() {
  const { mode } = useColorMode();
  const theme = getTheme(mode);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  );
}

// Initialize MSAL and process any pending redirect before rendering
Promise.all([
  registerImageResizeModule,
  msalInstance.initialize().then(() => msalInstance.handleRedirectPromise())
]).then(() => {
  const root = ReactDOM.createRoot(
    document.getElementById('root') 
  );
  root.render(
     <React.StrictMode>
    <BrowserRouter>
      <ColorModeProvider>
        <ThemedApp />
      </ColorModeProvider>
    </BrowserRouter>
  </React.StrictMode>
  );
}).catch(console.error);
